import { Card, Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import {
  InquiryDocumentResponse,
  IssuanceDocumentResponse
} from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  data?: InquiryDocumentResponse
  issuanceData?: IssuanceDocumentResponse
}

export const CommentSectionAdmin = ({ data, issuanceData }: Props) => {
  const { t } = useLocales()

  const palette = useTheme()

  const { styles } = useStyles()

  return (
    (data?.comment || issuanceData?.comment) && (
      <Card title={t('common.comment')} className={styles.commentCardWrapper}>
        <Flex vertical gap={8} className={styles.commentCard}>
          {data?.comment && (
            <>
              <Text size="lg">{t('stock_applications.beneficiary')}</Text>

              <div className={styles.commentBeneficiary}>{data?.comment}</div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {data?.commentBy?.firstName} {data?.commentBy?.lastName} -{' '}
                {data?.beneficiary?.name}
              </Text>
            </>
          )}
        </Flex>
        {issuanceData?.comment && (
          <>
            <Divider className={styles.commentDivider} />
            <Flex vertical gap={8} className={styles.commentCard}>
              <Text size="lg">{t('stock.provider')}</Text>
              <div className={styles.commentBeneficiary}>
                {issuanceData?.comment}
              </div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {issuanceData?.commentBy?.firstName}{' '}
                {issuanceData?.commentBy?.lastName} -{' '}
                {issuanceData?.supplier?.name}
              </Text>
            </Flex>
          </>
        )}
      </Card>
    )
  )
}
